export interface SheetMaterialInfo {
  type: string;       // e.g. "Лист ГК"
  thickness: number;  // mm, e.g. 2
  sheetW: number;     // mm, e.g. 1250
  sheetH: number;     // mm, e.g. 2500
  /** Grouping key: same type + thickness means parts are interchangeable across sheet sizes */
  groupKey: string;
  /** Human-readable group label, e.g. "Лист ГК · 2мм" */
  groupLabel: string;
}

// Matches: "Лист ГК 2х1250х2500мм", "Лист ГК 1.5х1250х2500 мм", "Лист ГК 1х1500х3000мм"
// Separators: х, x, ×, X
const SHEET_RE = /^(Лист\s+\S+)\s+([\d.]+)\s*[хxXх×]\s*([\d.]+)\s*[хxXх×]\s*([\d.]+)\s*мм\s*$/i;

export function parseSheetMaterial(material: string): SheetMaterialInfo | null {
  const m = SHEET_RE.exec(material.trim());
  if (!m) return null;

  const type = m[1].trim();
  const thickness = parseFloat(m[2]);
  const sheetW = parseFloat(m[3]);
  const sheetH = parseFloat(m[4]);

  if (isNaN(thickness) || isNaN(sheetW) || isNaN(sheetH)) return null;

  const groupKey = `${type}|${thickness}`;
  const groupLabel = `${type} · ${thickness}мм`;

  return { type, thickness, sheetW, sheetH, groupKey, groupLabel };
}
